var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPickUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "-62 0 512 512.001",
    width: "512pt",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#F5F5F5",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m342.234375 0h-81.003906c-24.804688 0-45 20.195312-45 45v26.992188h-23c-8.285157 0-15 6.71875-15 15 0 8.285156 6.714843 15 15 15h23.324219c3.816406 43.886718 40.664062 78.003906 85.175781 78.003906 47.21875 0 85.503906-38.285156 85.503906-85.503906 0-16.480469 0-32.996094 0-49.492188 0-24.804688-20.195313-45-45-45zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m266.777344 217.53125c-10.945313 4.941406-20.667969 12.101562-28.574219 20.894531l-80.640625 82.570313h-112.5625c-24.78125 0-45 20.222656-45 45.003906 0 24.777344 20.222656 45 45 45h126.003906c13.824219 0 27.527344-3.472656 37.820313-13.839844l13.410156-13.5v113.332032c0 7.265624 5.160156 13.625 12.015625 15.007812l138.003906-.007812c8.273438-.007813 14.980469-6.722657 14.980469-15v-201.496094c0-61.597656-63.984375-103.453125-120.457031-77.964844zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41.226562 290.996094h108.003907c8.285156 0 15-6.714844 15-15v-107c0-8.285156-6.714844-15-15-15h-39v25.765625c0 8.285156-6.71875 15-15 15-8.285157 0-15-6.714844-15-15v-25.765625h-39.003907c-8.28125 0-15 6.714844-15 15v107c0 8.285156 6.71875 15 15 15zm0 0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPickUp);
export default __webpack_public_path__ + "static/media/pick_up.2abd26847ffcc955651b92785c6c613d.svg";
export { ForwardRef as ReactComponent };